import React from "react";

import {NotFound} from "../components/NotFound/NotFound";

export const NotFoundView = () => <NotFound/>;